/** Default Tebox wordmark (black on transparent) — served from each app's `public/` folder. */
export const TEBOX_DEFAULT_LOGO_URL = '/tebox-logo.png';
/** Tebox wordmark for dark backgrounds (white on transparent). */
export const TEBOX_DEFAULT_LOGO_WHITE_URL = '/tebox-logo-white.png';
/** Tebox mark / app icon (black on transparent). */
export const TEBOX_DEFAULT_ICON_URL = '/tebox_icon.png';
/** Favicon + PWA touch icon paths (same assets in each app's `public/`). */
export const TEBOX_FAVICON_URL = '/favicon.ico';
export const TEBOX_APPLE_TOUCH_ICON_URL = '/apple-touch-icon.png';
//# sourceMappingURL=tebox-brand-assets.js.map